
export const common = {
  "home.awards.title": "Giải thưởng và danh hiệu",
  "home.awards.pause": "Tạm dừng trình chiếu giải thưởng",
  "home.awards.play": "Tiếp tục trình chiếu giải thưởng",
  "home.awards.financialAlgorithm": "Doanh nghiệp dẫn đầu về thuật toán tài chính",
  "home.awards.asiaPacificGold": "Thương hiệu hàng đầu về giao dịch vàng tại Châu Á – Thái Bình Dương",
  "home.awards.preciousMetals": "Thương hiệu giao dịch kim loại quý uy tín",
  "home.awards.digitalFinance": "Doanh nghiệp đóng góp cho đổi mới tài chính số",
  "home.awards.quantitativeTrading": "Doanh nghiệp xuất sắc về công nghệ giao dịch định lượng",
  // Navigation
  'nav.home': 'Trang chủ',
  'nav.trading': 'Giao dịch',
  'nav.markets': 'Thị trường',
  'nav.news': 'Tin tức',
  'nav.about': 'Giới thiệu',
  'nav.contact': 'Liên hệ',
  'nav.login': 'Đăng nhập',
  'nav.register': 'Đăng ký',

  // Hero Section
  'hero.title': 'Nền tảng giao dịch Vàng & Bạc cao cấp',
  'hero.subtitle': 'Công ty Hồng Kông được cấp phép cung cấp giao dịch kim loại quý an toàn, chuyên nghiệp cho nhà đầu tư trên toàn thế giới',
  'hero.cta.start': 'Bắt đầu giao dịch',
  'hero.cta.learn': 'Tải MT5',

  // Home
  'home.licenseHK': 'Được cấp phép tại Hồng Kông',
  'home.bankSec': 'Bảo mật cấp ngân hàng',
  'home.247s': 'Hỗ trợ 24/7',
  'home.global': 'Định hướng toàn cầu',
  'home.tradingPlat': 'Nền tảng giao dịch',
  'home.tradingWith': 'Giao dịch với ',
  'home.exp': 'Trải nghiệm nền tảng giao dịch tiên tiến nhất dành cho kim loại quý. MT5 cung cấp công cụ cấp tổ chức, khớp lệnh siêu nhanh và phân tích thị trường toàn diện.',
  'home.dlMT5': 'Tải MT5',
  'home.watchDemo': 'Xem demo',
  'home.tradingIns': 'Sản phẩm giao dịch',
  'home.exeSpeed': 'Tốc độ khớp lệnh',
  'home.mktAccess': 'Truy cập thị trường',
  'home.uptime': 'Thời gian hoạt động',
  'home.allDevices': 'Có trên mọi thiết bị',
  'home.mktInt': 'Thông tin thị trường',
  'home.mktInt.desc': 'Cập nhật theo thời gian thực các sự kiện kinh tế và tin tức ảnh hưởng đến giao dịch kim loại quý',
  'home.lastUpdate': 'Cập nhật lần cuối',
  'home.ecoCal': 'Lịch kinh tế',
  'home.refresh': 'Làm mới',
  'home.currency': 'Tiền tệ',
  'home.events': 'Sự kiện',
  'home.previous': 'Trước đó',
  'home.forecast': 'Dự báo',
  'home.actual': 'Thực tế',
  'home.mktNews': 'Tin thị trường',
  'home.seeMore': 'Xem thêm',
  'home.ecoData': 'Dữ liệu kinh tế từ nhiều nhà cung cấp tài chính • Tin thị trường từ các ấn phẩm tài chính hàng đầu',
  'home.ac': 'Biểu đồ nâng cao',
  'home.pta': 'Phân tích kỹ thuật chuyên nghiệp với 80+ chỉ báo và công cụ phân tích',
  'home.mpa': 'Truy cập đa nền tảng',
  'home.tsa': 'Giao dịch liền mạch trên máy tính, web và di động',
  'home.st': 'Giao dịch an toàn',
  'home.bls': 'Bảo mật cấp ngân hàng với truyền tải và lưu trữ dữ liệu được mã hóa',
  'home.247': 'Truy cập thị trường 24/7',
  'home.rtc': 'Truy cập giao dịch suốt ngày đêm tới các thị trường kim loại quý toàn cầu',
  'home.at': 'Giao dịch tự động',
  'home.ea': 'Expert Advisors (EA) cho chiến lược giao dịch thuật toán và tự động',
  'home.lfe': 'Khớp lệnh siêu tốc',
  'home.ull': 'Thực thi lệnh độ trễ cực thấp với spread cạnh tranh',

  // Features
  'features.title': 'Vì sao chọn nền tảng của chúng tôi',
  'features.security.title': 'Bảo mật cấp ngân hàng',
  'features.security.desc': 'Mã hóa nâng cao và nhiều lớp bảo mật bảo vệ khoản đầu tư của bạn',
  'features.licensed.title': 'Được cấp phép đầy đủ',
  'features.licensed.desc': 'Công ty Hồng Kông được quản lý với tuân thủ và minh bạch đầy đủ',
  'features.realtime.title': 'Giao dịch theo thời gian thực',
  'features.realtime.desc': 'Dữ liệu thị trường trực tiếp và khớp lệnh tức thì cho cơ hội tối ưu',
  'features.support.title': 'Hỗ trợ 24/7',
  'features.support.desc': 'Đội ngũ hỗ trợ đa ngôn ngữ chuyên nghiệp hoạt động suốt ngày đêm',
  'features.lmd': 'Dữ liệu thị trường trực tiếp',
  'features.rtp': 'Giá kim loại quý theo thời gian thực',

  // Markets
  'markets.title': 'Giá thị trường trực tiếp',
  'markets.gold': 'Vàng',
  'markets.silver': 'Bạc',
  'markets.platinum': 'Bạch kim',
  'markets.palladium': 'Palladium',
  'markets.price': 'Giá',
  'markets.change': 'Thay đổi',
  'markets.high': 'Cao nhất 24h',
  'markets.low': 'Thấp nhất 24h',
  'markets.contractDetials': 'Chi tiết hợp đồng',
  'markets.contractDetials.desc': 'Thông số hợp đồng và điều kiện giao dịch toàn diện cho kim loại quý',
  'markets.tradingExample': 'Ví dụ giao dịch',
  'markets.goldExample': 'Ví dụ giao dịch Vàng',
  'markets.silverExample': 'Ví dụ giao dịch Bạc',
  'markets.instrument': 'Sản phẩm',
  'markets.lotSize': 'Kích thước lot',
  'markets.entPrice': 'Giá vào lệnh',
  'markets.marReq': 'Ký quỹ yêu cầu',
  'markets.pip': 'Giá trị pip',
  'markets.pmt': 'Giao dịch kim loại quý',
  'markets.ctt': 'Các điều khoản, điều kiện và thông số giao dịch toàn diện cho kim loại quý. Hiểu chi tiết hợp đồng, yêu cầu ký quỹ và quản trị rủi ro cho đầu tư vàng và bạc.',
  'markets.vts': 'Xem thông số giao dịch',
  'markets.dcd': 'Tải chi tiết hợp đồng',
  'markets.ec': 'Tốc độ khớp lệnh',
  'markets.th': 'Giờ giao dịch',
  'markets.ms': 'Spread tối thiểu (pip)',
  'markets.ml': 'Đòn bẩy tối đa',
  'markets.mr': 'Yêu cầu ký quỹ',
  'markets.lo': 'Tùy chọn đòn bẩy và yêu cầu ký quỹ theo từng loại tài khoản',
  'markets.leverage': 'Đòn bẩy',
  'markets.margin': 'Ký quỹ',
  'markets.mind': 'Tiền nạp tối thiểu',
  'markets.mc': 'Máy tính ký quỹ',
  'markets.gmc': 'Tính ký quỹ Vàng',
  'markets.cp': 'Giá hiện tại',
  'markets.cv': 'Giá trị hợp đồng',
  'markets.smc': 'Tính ký quỹ Bạc',
  'markets.rm': 'Quản trị rủi ro',
  'markets.crm': 'Công cụ và chiến lược quản trị rủi ro toàn diện để bảo vệ khoản đầu tư',
  'markets.rtg': 'Hướng dẫn khẩu vị rủi ro',
  'markets.rd': 'Công bố rủi ro',
  'markets.tpm': 'Giao dịch kim loại quý tiềm ẩn rủi ro thua lỗ đáng kể và có thể không phù hợp với mọi nhà đầu tư. Hiệu suất trong quá khứ không phản ánh kết quả tương lai.',
  'markets.lcw': 'Đòn bẩy có thể chống lại bạn cũng như hỗ trợ bạn. Trước khi quyết định giao dịch, hãy cân nhắc kỹ mục tiêu đầu tư, mức độ kinh nghiệm và khả năng chấp nhận rủi ro.',
  'markets.ysb': 'Bạn nên nhận thức tất cả rủi ro liên quan đến giao dịch kim loại quý và tham khảo ý kiến cố vấn tài chính độc lập nếu còn băn khoăn.',
  'markets.rfr': 'Đọc đầy đủ Công bố rủi ro',
  'markets.cra': 'Liên hệ cố vấn rủi ro',
  'markets.tho': 'Giờ giao dịch',
  'markets.moh': 'Giờ hoạt động thị trường và lịch ngày lễ cho giao dịch kim loại quý',
  'markets.wts': 'Lịch giao dịch hàng tuần',
  'markets.note': 'Lưu ý',
  'markets.atad': 'Tất cả thời gian hiển thị theo GMT+8. Giao dịch có thể tạm ngừng trong các kỳ nghỉ lớn và giai đoạn biến động mạnh.',
  'markets.hs': 'Lịch nghỉ lễ',
  'markets.mclo': 'Thị trường đóng cửa',
  'markets.eclo': 'Đóng cửa sớm',
  'markets.hn': 'Thông báo nghỉ lễ',
  'markets.thm': 'Giờ giao dịch có thể điều chỉnh trong các ngày lễ quốc gia. Vui lòng theo dõi thông báo của chúng tôi.',
  'markets.cms': 'Trạng thái thị trường hiện tại',
  'markets.mac': 'Thị trường hiện ĐANG MỞ để giao dịch',
  'markets.st': 'Giờ máy chủ (GMT+8)',
  'markets.ts': 'Thông số giao dịch',
  'markets.dtc': 'Điều kiện và thông số chi tiết cho sản phẩm Vàng và Bạc',
  'markets.msp': 'Spread tối thiểu',
  'markets.minls': 'Lot tối thiểu',
  'markets.maxls': 'Lot tối đa',
  'markets.commission': 'Hoa hồng',
  'markets.sls': 'Swap Long/Short',
  'markets.in': 'Lưu ý quan trọng',
  'markets.smv': 'Spread có thể thay đổi trong thời kỳ biến động cao và sự kiện tin tức lớn',
  'markets.sra': 'Lãi suất swap được cập nhật hàng ngày và có thể thay đổi theo điều kiện thị trường',
  'markets.mlm': 'Đòn bẩy tối đa có thể giảm trong các sự kiện tin tức tác động mạnh',
  'markets.ata': 'Tất cả thời gian hiển thị theo múi giờ GMT+8',

  // News
  'news.title': 'Tin tức & Phân tích thị trường mới nhất',
  'news.subtitle': 'Luôn nắm bắt với góc nhìn chuyên gia và cập nhật thị trường',
  'news.readMore': 'Đọc thêm',
  'news.category.analysis': 'Phân tích thị trường',
  'news.category.news': 'Tin nóng',
  'news.category.insights': 'Góc nhìn chuyên gia',
  'news.category.education': 'Kiến thức',
  'news.date': 'Ngày đăng',
  'news.author': 'Bởi',

  // Testimonials
  'home.partners.title': 'Đối tác của chúng tôi',
  'home.partners.subtitle': 'Hợp tác cùng các nhà cung cấp hàng đầu thế giới về thanh khoản, công nghệ tài chính và hạ tầng giao dịch.',
  'testimonials.title': 'Được nhà đầu tư toàn cầu tin tưởng',
  'testimonials.client1.name': 'Marcus Weber',
  'testimonials.client1.location': 'Frankfurt, Đức',
  'testimonials.client1.text': 'Nền tảng xuất sắc với biểu phí minh bạch và khớp lệnh đáng tin cậy. Tính năng bảo mật khiến tôi hoàn toàn yên tâm.',
  'testimonials.client2.name': 'Sophie Dubois',
  'testimonials.client2.location': 'Paris, Pháp',
  'testimonials.client2.text': 'Dịch vụ chuyên nghiệp và spread cạnh tranh. Đội hỗ trợ đa ngôn ngữ cực kỳ hữu ích.',
  'testimonials.client3.name': 'Alessandro Rossi',
  'testimonials.client3.location': 'Milan, Ý',
  'testimonials.client3.text': 'Khớp lệnh nhanh và công cụ phân tích thị trường tuyệt vời. Rất đáng khuyến nghị cho giao dịch kim loại quý nghiêm túc.',

  // Footer
  'footer.company': 'Công ty',
  'footer.trading': 'Giao dịch',
  'footer.support': 'Hỗ trợ',
  'footer.legal': 'Pháp lý',
  'footer.about': 'Về chúng tôi',
  'footer.careers': 'Tuyển dụng',
  'footer.news': 'Tin tức',
  'footer.platforms': 'Nền tảng giao dịch',
  'footer.education': 'Học viện',
  'footer.analysis': 'Phân tích thị trường',
  'footer.help': 'Trung tâm trợ giúp',
  'footer.contact': 'Liên hệ chúng tôi',
  'footer.faq': 'Hỏi đáp',
  'footer.terms': 'Điều khoản dịch vụ',
  'footer.privacy': 'Chính sách quyền riêng tư',
  'footer.risk': 'Công bố rủi ro',
  'footer.copyright': '© 2024 GOLD Label Global Limited. Bảo lưu mọi quyền.',
  'footer.license': "Công ty được thành lập tại Hồng Kông",
  'footer.riskwarning': 'Cảnh báo rủi ro',
  'footer.disclaimer': 'Giao dịch ký quỹ là sản phẩm tài chính có đòn bẩy có thể dẫn đến thua lỗ vượt quá số tiền bạn đã nạp. Bạn không thực sự sở hữu hay nắm giữ bất kỳ tài sản cơ sở nào. Vui lòng đọc kỹ Tuyên bố Công bố Rủi ro trước khi giao dịch. Hãy đảm bảo bạn hiểu đầy đủ rủi ro liên quan và quản trị mức độ rủi ro một cách thận trọng. Chúng tôi không chịu trách nhiệm cho bất kỳ hành động hoặc không hành động nào của cá nhân dựa trên thông tin trên website này hoặc nội dung của nó.',
  'footer.jurisdiction': "Thông báo về phạm vi tài phán",
  'footer.jurisdictionDisclaimer': "Các dịch vụ được mô tả trên trang web này chỉ được cung cấp cho khách hàng đủ điều kiện tại các khu vực tài phán ngoài Hồng Kông và Hoa Kỳ, với điều kiện việc cung cấp các dịch vụ đó được pháp luật áp dụng tại khu vực tài phán của khách hàng cho phép. Dịch vụ không được cung cấp cho cư dân Hồng Kông hoặc Hoa Kỳ, cũng như cho bất kỳ cá nhân nào tại khu vực tài phán nơi các dịch vụ đó là bất hợp pháp hoặc bị cấm. Trang web này không hướng đến người tại các khu vực tài phán bị hạn chế và không cấu thành lời chào mời, đề nghị hoặc khuyến nghị đối với những người đó.",
  'footer.relatedEntity': 'Pháp nhân liên quan khác',
  'footer.saintLuciaEntity': 'Gold Label Global (SL) Limited là một Công ty Kinh doanh Quốc tế được thành lập tại Saint Lucia vào ngày 4 tháng 9 năm 2026, mã số đăng ký 2026-00680. Trụ sở đăng ký: Ground Floor, The Sotheby Building, Rodney Village, Rodney Bay, Gros-Islet, Saint Lucia. Trụ sở đăng ký chỉ được duy trì nhằm đáp ứng các yêu cầu tuân thủ pháp luật và quy định. Đây không phải là địa điểm kinh doanh thực tế của công ty và không được sử dụng cho hoạt động, tiếp khách hàng hoặc thư tín.',
  'footer.regNo': 'Mã số đăng ký công ty',

  // Common
  'common.language': 'Ngôn ngữ',
  'common.loading': 'Đang tải...',
  'common.error': 'Lỗi',
  'common.success': 'Thành công',
  'common.close': 'Đóng',
  'common.save': 'Lưu',
  'common.cancel': 'Hủy',
  'common.continue': 'Tiếp tục',
  'common.back': 'Quay lại',
  'common.next': 'Tiếp theo',
  'common.previous': 'Trước',
  'common.submit': 'Gửi',
  'common.reset': 'Đặt lại',

  // About
  'about.yearsOfExp': 'Số năm kinh nghiệm',
  'about.yearsOfExp.desc': 'Hàng thập kỷ chuyên môn trong giao dịch kim loại quý',
  'about.dailyTrade': 'Khối lượng giao dịch hằng ngày',
  'about.dailyTrade.desc': '80 tỷ HK$ giao dịch vàng và bạc mỗi ngày',
  'about.satClients': 'Khách hàng hài lòng',
  'about.satClients.desc': 'Phục vụ vô số khách hàng và tổ chức trên toàn thế giới',
  'about.exeSpeed': 'Tốc độ khớp lệnh',
  'about.exeSpeed.desc': 'Công nghệ khớp lệnh siêu tốc',
  'about.ourAch': 'Thành tựu của chúng tôi',
  'about.ourAch.desc': 'Được công nhận xuất sắc trong giao dịch kim loại quý với hiệu suất dẫn đầu ngành',
  'about.companyProfile': 'Hồ sơ công ty',
  'about.about1': 'Giới thiệu Gold Label Global',
  'about.about2': 'Gold Label Global Limited là công ty trách nhiệm hữu hạn đã đăng ký, được chính phủ Hồng Kông phê duyệt và cũng là thành viên của Hội Giao dịch Vàng và Bạc Trung Quốc. Hồng Kông xử lý giao dịch vàng và bạc trị giá 80 tỷ HK$ mỗi ngày, với kinh nghiệm dẫn đầu thế giới.',
  'about.about3': 'Đội ngũ quản lý của Gold Label Global có hơn hai mươi năm tập trung vào giao dịch vàng và bạc. Chúng tôi đã phục vụ vô số khách hàng và tổ chức, xử lý các giao dịch của khách hàng lên đến hàng chục tỷ. Chúng tôi nhận được đánh giá cao từ khách hàng và các chuyên gia trong ngành.',
  'about.about4': 'Chúng tôi cam kết mang đến cho khách hàng môi trường giao dịch nhanh, ổn định và xuất sắc. Về mặt kỹ thuật, chúng tôi áp dụng hệ thống giao dịch tiêu chuẩn quốc tế và lựa chọn các đội ngũ công nghệ hàng đầu để phát triển những chương trình giao dịch mạnh mẽ, toàn diện hơn, cải thiện tốc độ giao dịch nhanh hơn, ổn định hơn và toàn diện hơn.',
  'about.about5': 'Gold Label Global sẽ tiếp tục tạo ra lợi nhuận cùng bạn và chia sẻ sự thịnh vượng.',
  'about.about6': 'Khám phá hành trình giao dịch kim loại quý của chúng tôi và cam kết về sự xuất sắc trên thị trường tài chính toàn cầu.',
  'about.about7': 'Là công ty trách nhiệm hữu hạn đã đăng ký được chính phủ Hồng Kông phê duyệt và là thành viên của Hội Giao dịch Vàng & Bạc Trung Quốc, chúng tôi xử lý 80 tỷ HK$ giao dịch vàng và bạc mỗi ngày, dẫn đầu thế giới về kinh nghiệm giao dịch.',
  'about.proTeam': 'Đội ngũ chuyên nghiệp',
  'about.proTeam.desc': 'Đội ngũ quản lý của chúng tôi có hơn 20 năm kinh nghiệm tập trung vào giao dịch vàng và bạc, đã phục vụ vô số khách hàng và tổ chức.',
  'about.proService': 'Dịch vụ chuyên nghiệp',
  'about.proService.desc': 'Đội ngũ chăm sóc khách hàng chuyên nghiệp cung cấp hỗ trợ trực tuyến 24 giờ và tư vấn di động, cũng như giải pháp mục tiêu cho vấn đề của khách hàng.',
  'about.sec': 'An toàn là trên hết',
  'about.sec.desc': 'Không có đối tác giao dịch đối ứng, lệnh đi thẳng vào thị trường; giao dịch minh bạch, an toàn và bảo mật.',
  'about.strict': 'Giám sát nghiêm ngặt',
  'about.strict.desc': 'Gold Label Global là địa điểm giao dịch thương mại tại Hồng Kông, được chính phủ Hồng Kông quản lý và là thành viên của Hiệp hội Thương mại Hồng Kông.',
  'about.fastDes': 'Nạp tiền nhanh',
  'about.fastDes.desc': 'Cung cấp dịch vụ 24/7 trong ngành, nạp tiền trong vài giây, mở tài khoản tức thì.',
  'about.productSafe': 'An toàn sản phẩm',
  'about.productSafe.desc': 'Bao phủ mọi sản phẩm kim loại quý lớn trên toàn cầu, an toàn và bảo mật.',
  'about.whyGLB': 'Vì sao chọn Gold Label Global',
  'about.whyGLB.desc': 'Khám phá những lợi thế giúp chúng tôi trở thành lựa chọn hàng đầu cho giao dịch kim loại quý',
  'about.readyToStart': 'Sẵn sàng bắt đầu giao dịch?',
  'about.join': 'Tham gia hàng nghìn khách hàng hài lòng tin tưởng GOLD Label Global cho nhu cầu giao dịch kim loại quý.',
  'about.openTradingAcc': 'Mở tài khoản giao dịch',
  'about.contactTeam': 'Liên hệ đội ngũ của chúng tôi',
  'about.co': 'Hợp tác',
  'about.co.desc': 'Xây dựng quan hệ đối tác cùng có lợi với khách hàng và các bên liên quan',
  'about.safety': 'An toàn',
  'about.safety.desc': 'Đảm bảo mức độ bảo mật cao nhất cho mọi hoạt động giao dịch',
  'about.integrity': 'Liêm chính',
  'about.integrity.desc': 'Duy trì các tiêu chuẩn cao nhất về trung thực và minh bạch',
  'about.professional': 'Chuyên nghiệp',
  'about.professional.desc': 'Cung cấp dịch vụ chuyên gia với tính chuyên nghiệp vượt trội',
  'about.fast': 'Nhanh chóng',
  'about.fast.desc': 'Cung cấp khớp lệnh nhanh và dịch vụ khách hàng phản hồi kịp thời',
  'about.coreValue': 'Giá trị cốt lõi của chúng tôi',
  'about.coreValue.desc': 'Những nguyên tắc định hướng cam kết về sự xuất sắc trong giao dịch kim loại quý',

  // Contact
  'contact.sendUsMsg': 'Gửi tin nhắn cho chúng tôi',
  'contact.fillOut': 'Điền vào biểu mẫu dưới đây và đội ngũ của chúng tôi sẽ phản hồi trong vòng 24 giờ.',
  'contact.inqType': 'Loại yêu cầu',
  'contact.genInq': 'Yêu cầu chung',
  'contact.accSup': 'Hỗ trợ tài khoản',
  'contact.traSup': 'Hỗ trợ giao dịch',
  'contact.techSup': 'Hỗ trợ kỹ thuật',
  'contact.partner': 'Đối tác',
  'contact.fullname': 'Họ và tên *',
  'contact.email': 'Địa chỉ email *',
  'contact.phone': 'Số điện thoại',
  'contact.subject': 'Chủ đề *',
  'contact.msg': 'Nội dung *',
  'contact.sendMsg': 'Gửi tin nhắn',
  'contact.whyUs': 'Vì sao chọn chúng tôi?',
  'contact.regSec': 'Được quản lý & an toàn',
  'contact.licAndReg': 'Môi trường giao dịch được cấp phép và quản lý với các biện pháp bảo mật nâng cao để bảo vệ khoản đầu tư của bạn.',
  'contact.expSup': 'Hỗ trợ chuyên gia',
  'contact.proService': 'Các chuyên gia giao dịch sẵn sàng 24/7 để hỗ trợ nhu cầu và câu hỏi giao dịch của bạn.',
  'contact.fastExe': 'Khớp lệnh nhanh',
  'contact.lightFast': 'Khớp lệnh siêu tốc với trượt giá tối thiểu cho hiệu quả giao dịch tối ưu.',
  'contact.glbNet': 'Thị trường toàn cầu',
  'contact.asscessToint': 'Truy cập các thị trường kim loại quý quốc tế với spread cạnh tranh và thanh khoản sâu.',
  'contact.followUs': 'Theo dõi chúng tôi trên mạng xã hội:',
  'contact.contactOutPro': 'Liên hệ đội ngũ chuyên nghiệp của chúng tôi để được hỗ trợ giao dịch, trợ giúp tài khoản hoặc các yêu cầu chung:',
  'contact.officeAddress': 'Địa chỉ văn phòng',
  'contact.bussHour': 'Giờ làm việc: Thứ Hai–Thứ Sáu 9:00–18:00 (GMT+8)',
  'contact.phoneSupp': 'Hỗ trợ qua điện thoại',
  'contact.mainOffice': 'Văn phòng chính',
  'contact.availableServices': 'Dịch vụ hiện có:',
  'contact.accOpenSup': 'Hỗ trợ mở tài khoản',
  'contact.tradSup': 'Hỗ trợ nền tảng giao dịch',
  'contact.genSup': 'Hỗ trợ chung',
  'contact.emailSup': 'Hỗ trợ qua email',
  'contact.responseTime': 'Thời gian phản hồi:',
  'contact.genInq24': 'Yêu cầu chung: Trong vòng 24 giờ',
  'contact.techSup24': 'Hỗ trợ kỹ thuật: Trong vòng 4 giờ',
  'contact.accIss24': 'Sự cố tài khoản: Trong vòng 2 giờ',
  'contact.needImSup': 'Cần hỗ trợ ngay?',
  'contact.needImSup.desc': 'Các chuyên gia giao dịch của chúng tôi sẵn sàng 24/7 để hỗ trợ bạn với các vấn đề giao dịch khẩn cấp và hỗ trợ tài khoản.',
  'contact.callNow': 'Gọi ngay',
  'contact.sendEmail': 'Gửi email',
  'contact.contactUs': 'Liên hệ với chúng tôi',
  'contact.getInTouch': 'Kết nối với đội ngũ giao dịch chuyên nghiệp của chúng tôi. Chúng tôi luôn ở đây để giúp bạn thành công trong giao dịch kim loại quý.',
  'contact.247Sup': 'Hỗ trợ 24/7',
  'contact.247Sup.desc': 'Dịch vụ khách hàng suốt ngày đêm cho mọi nhu cầu giao dịch của bạn',
  'contact.dirLine': 'Đường dây trực tiếp',
  'contact.dirLine.desc': 'Trò chuyện trực tiếp với các chuyên gia giao dịch của chúng tôi',
  'contact.hkOffice': 'Văn phòng Hồng Kông',
  'contact.hkOffice.desc': 'Nằm tại trung tâm khu tài chính Hồng Kông',

  // Platform
  'platform.wco': 'Vì sao chọn nền tảng MT5 của chúng tôi?',
  'platform.etd': 'Cảm nhận khác biệt với nền tảng giao dịch cao cấp dành cho nhà giao dịch nghiêm túc',
  'platform.rts': 'Sẵn sàng bắt đầu giao dịch?',
  'platform.jto': 'Tham gia hàng nghìn nhà giao dịch tin tưởng nền tảng của chúng tôi cho giao dịch kim loại quý',
  'platform.ola': 'Mở tài khoản thật',
  'platform.tda': 'Thử tài khoản demo',
  'platform.dmt': 'Tải nền tảng MT5',
  'platform.ayt': 'Truy cập tài khoản giao dịch của bạn từ mọi thiết bị với các ứng dụng MT5 đa nền tảng',
  'platform.free': 'Miễn phí',
  'platform.dn': 'Tải ngay',
  'platform.sr': 'Yêu cầu hệ thống',
  'platform.nh': 'Cần trợ giúp bắt đầu?',
  'platform.os': 'Đội ngũ hỗ trợ của chúng tôi sẵn sàng giúp bạn thiết lập và bắt đầu giao dịch',
  'platform.ug': 'Hướng dẫn sử dụng',
  'platform.cs': 'Liên hệ hỗ trợ',
  'platform.si': 'Cần kết nối internet ổn định',
  'platform.ptf': 'Tính năng giao dịch mạnh mẽ',
  'platform.epg': 'Trải nghiệm các công cụ giao dịch cấp chuyên nghiệp dành cho cả người mới và chuyên gia',
  'platform.ac': 'Biểu đồ nâng cao',
  'platform.pct': 'Công cụ biểu đồ chuyên nghiệp với 80+ chỉ báo kỹ thuật và nhiều khung thời gian cho phân tích toàn diện.',
  'platform.lfe': 'Khớp lệnh siêu nhanh',
  'platform.ull': 'Giao dịch độ trễ cực thấp với tốc độ thực thi nhanh tới 0,01 giây cho điểm vào/ra tối ưu.',
  'platform.ea': 'Expert Advisors (EA)',
  'platform.atc': 'Khả năng giao dịch tự động với EA tùy chỉnh và chiến lược thuật toán.',
  'platform.rm': 'Quản trị rủi ro',
  'platform.crm': 'Bộ công cụ quản trị rủi ro toàn diện gồm dừng lỗ, chốt lời và kiểm soát khối lượng vị thế.',
  'platform.mpa': 'Truy cập đa nền tảng',
  'platform.tsa': 'Giao dịch liền mạch trên máy tính, web và di động với truy cập tài khoản đồng bộ.',
  'platform.gm': 'Thị trường toàn cầu',
  'platform.ati': 'Truy cập các thị trường quốc tế gồm kim loại quý, forex, chỉ số và hàng hóa.',
  'platform.etw': 'Trải nghiệm nền tảng giao dịch tiên tiến nhất thế giới. Giao dịch kim loại quý, forex và CFD với công nghệ cấp tổ chức và khớp lệnh siêu nhanh.',
  'platform.download': 'Tải xuống ',
  'platform.wd': 'Xem demo',
  'platform.es': 'Tốc độ thực thi',
  'platform.th': 'Giờ giao dịch',
  'platform.in': 'Sản phẩm',
  'platform.lt': 'Giao dịch trực tiếp',
  'platform.ptt': 'Công cụ giao dịch chuyên nghiệp',
  'platform.aig': 'Truy cập các công cụ cấp tổ chức dành cho nhà giao dịch chuyên nghiệp và nhà đầu tư nghiêm túc',
  'platform.rtd': 'Dữ liệu thời gian thực',
  'platform.lmd': 'Dữ liệu thị trường trực tiếp và cập nhật giá tức thì',
  'platform.pa': 'Cảnh báo giá',
  'platform.caf': 'Cảnh báo tùy chỉnh cho biến động giá và sự kiện thị trường',
  'platform.this': 'Lịch sử giao dịch',
  'platform.cth': 'Lịch sử giao dịch và phân tích hiệu suất toàn diện',
  'platform.ec': 'Lịch kinh tế',
  'platform.suw': 'Cập nhật các sự kiện kinh tế quan trọng',
  'platform.mw': 'Theo dõi thị trường',
  'platform.rtp': 'Báo giá theo thời gian thực và độ sâu thị trường cho tất cả sản phẩm',
  'platform.om': 'Quản lý lệnh',
  'platform.aot': 'Các loại lệnh nâng cao gồm thị trường, giới hạn, dừng và dừng kéo',
  'platform.ta': 'Phân tích kỹ thuật',
  'platform.cta': 'Bộ công cụ phân tích kỹ thuật toàn diện với chỉ báo tùy chỉnh và công cụ vẽ',
  'platform.ufe': 'Thực thi siêu nhanh',
  'platform.rtc': 'Hỗ trợ khách hàng suốt ngày đêm từ đội ngũ chuyên gia giao dịch và kỹ thuật',
  'platform.247a': 'Hoạt động 24/7',
  'platform.csp': 'Spread cạnh tranh',
  'platform.iia': 'Spread dẫn đầu ngành và báo giá minh bạch, không phí ẩn hay hoa hồng',
  'platform.01pip': 'Từ 0.1 pip',
  'platform.ffd': 'Ứng dụng máy tính đầy đủ tính năng cho Windows 10/11',
  'platform.nma': 'Ứng dụng gốc cho macOS với đầy đủ chức năng',
  'platform.mta': 'Ứng dụng giao dịch cho Android',
  'platform.iai': 'Ứng dụng giao dịch cho iPhone và iPad',

  // FAQ SECTION
  'faq.tagline': 'CHÚNG TÔI CÓ THỂ GIÚP GÌ CHO BẠN?',
  'faq.title': 'Chúng tôi có thể giúp gì cho bạn?',
  'faq.subtitle': 'Duyệt các mục Câu hỏi thường gặp toàn diện để tìm câu trả lời nhanh cho thắc mắc của bạn',
  'faq.categories': 'Danh mục',

  // Footer help box
  'faq.cantFind': 'Không tìm thấy điều bạn cần?',
  'faq.supportText': 'Đội hỗ trợ của chúng tôi sẵn sàng giúp bạn với mọi câu hỏi chưa được đề cập trong mục Câu hỏi thường gặp.',
  'faq.contactSupport': 'Liên hệ đội hỗ trợ',

  // Category titles
  'faq.general': 'Chung',
  'faq.account': 'Tài khoản',
  'faq.trading': 'Giao dịch',
  'faq.platform': 'Nền tảng',
  'faq.deposits': 'Nạp & Rút tiền',
  'faq.security': 'Bảo mật',

  // General
  'faq.general.q1': 'GOLD LABEL GLOBAL LIMITED là gì?',
  'faq.general.a1': 'GOLD LABEL GLOBAL LIMITED là công ty giao dịch kim loại quý được quản lý có trụ sở tại Hồng Kông, cung cấp dịch vụ giao dịch chuyên nghiệp cho vàng, bạc và các kim loại quý khác thông qua nền tảng MT5.',
  'faq.general.q2': 'Bạn cung cấp những sản phẩm giao dịch nào?',
  'faq.general.a2': 'Chúng tôi cung cấp danh mục kim loại quý toàn diện gồm vàng giao ngay (XAU/USD), bạc giao ngay (XAG/USD), bạch kim, palladium và nhiều hợp đồng tương lai kim loại quý.',
  'faq.general.q3': 'Giờ giao dịch của bạn là gì?',
  'faq.general.a3': 'Thị trường kim loại quý của chúng tôi mở cửa 24 giờ mỗi ngày, 5 ngày mỗi tuần, từ Chủ Nhật 5:00 PM EST đến Thứ Sáu 4:00 PM EST, theo giờ giao dịch quốc tế.',
  'faq.general.q4': 'Khoản đầu tư của tôi có an toàn với công ty không?',
  'faq.general.a4': 'Có, chúng tôi được quản lý và cấp phép đầy đủ. Tiền của khách hàng được tách biệt và giữ tại các tài khoản ngân hàng an toàn. Chúng tôi cũng duy trì bảo hiểm toàn diện để bảo vệ bổ sung.',

  // Account
  'faq.account.q1': 'Làm sao để mở tài khoản giao dịch?',
  'faq.account.a1': 'Bạn có thể mở tài khoản trực tuyến bằng cách hoàn thành biểu mẫu đăng ký, cung cấp giấy tờ tùy thân cần thiết và nạp tiền ban đầu. Quá trình thường mất 1–2 ngày làm việc.',
  'faq.account.q2': 'Mức nạp tối thiểu là bao nhiêu?',
  'faq.account.a2': 'Khoản nạp ban đầu tối thiểu là 1.000 USD cho tài khoản tiêu chuẩn. Chúng tôi cũng cung cấp tài khoản premium với mức nạp cao hơn và nhiều quyền lợi bổ sung.',
  'faq.account.q3': 'Tôi có thể có nhiều tài khoản giao dịch không?',
  'faq.account.a3': 'Có, bạn có thể mở nhiều tài khoản với các đồng tiền cơ sở hoặc loại tài khoản khác nhau để phù hợp với chiến lược và quản trị rủi ro.',
  'faq.account.q4': 'Xác minh tài khoản như thế nào?',
  'faq.account.a4': 'Xác minh tài khoản yêu cầu giấy tờ tùy thân do chính phủ cấp (hộ chiếu hoặc bằng lái xe) và chứng minh địa chỉ (hóa đơn điện/nước hoặc sao kê ngân hàng) trong vòng 3 tháng gần nhất.',

  // Trading
  'faq.trading.q1': 'Khối lượng lệnh tối thiểu là bao nhiêu?',
  'faq.trading.a1': 'Khối lượng lệnh tối thiểu là 0.01 lot cho hầu hết sản phẩm kim loại quý, cho phép linh hoạt quản trị khối lượng và rủi ro cho mọi cấp độ nhà giao dịch.',
  'faq.trading.q2': 'Bạn cung cấp mức đòn bẩy nào?',
  'faq.trading.a2': 'Chúng tôi cung cấp đòn bẩy cạnh tranh lên đến 1:100 cho giao dịch kim loại quý, giúp tối đa hóa tiềm năng giao dịch đồng thời duy trì quản trị rủi ro có trách nhiệm.',
  'faq.trading.q3': 'Có phí giao dịch nào không?',
  'faq.trading.a3': 'Chúng tôi hoạt động theo mô hình spread, không thu phí hoa hồng. Spread của chúng tôi cạnh tranh và minh bạch, không có chi phí ẩn hay phụ phí bất ngờ.',
  'faq.trading.q4': 'Tôi có thể dùng chiến lược giao dịch tự động không?',
  'faq.trading.a4': 'Có, nền tảng MT5 của chúng tôi hỗ trợ đầy đủ Expert Advisors (EA) và các chiến lược giao dịch tự động. Bạn có thể phát triển thuật toán tùy chỉnh hoặc sử dụng robot sẵn có.',

  // Platform
  'faq.platform.q1': 'Bạn hỗ trợ những nền tảng giao dịch nào?',
  'faq.platform.a1': 'Chúng tôi chủ yếu sử dụng MetaTrader 5 (MT5) – nền tảng giao dịch hàng đầu. MT5 có sẵn cho máy tính (Windows/Mac), di động (iOS/Android) và trình duyệt web.',
  'faq.platform.q2': 'MT5 có miễn phí sử dụng không?',
  'faq.platform.a2': 'Có, MT5 hoàn toàn miễn phí tải về và sử dụng. Chúng tôi cung cấp đầy đủ tính năng nền tảng, biểu đồ, chỉ báo và công cụ giao dịch mà không tính thêm phí.',
  'faq.platform.q3': 'Tôi có thể giao dịch trên thiết bị di động không?',
  'faq.platform.a3': 'Chắc chắn! Ứng dụng MT5 cho iOS và Android cung cấp đầy đủ chức năng giao dịch, biểu đồ thời gian thực, tin tức thị trường và quản lý tài khoản khi di chuyển.',
  'faq.platform.q4': 'Bạn có cung cấp tài khoản demo không?',
  'faq.platform.a4': 'Có, chúng tôi cung cấp tài khoản demo miễn phí với tiền ảo để bạn luyện tập và làm quen nền tảng trước khi đầu tư tiền thật.',

  // Deposits & Withdrawals
  'faq.deposits.q1': 'Bạn chấp nhận những phương thức nạp tiền nào?',
  'faq.deposits.a1': 'Chúng tôi chấp nhận chuyển khoản ngân hàng, thẻ tín dụng/ghi nợ (Visa, MasterCard) và nhiều phương thức thanh toán điện tử. Tất cả giao dịch nạp tiền được xử lý an toàn và hiệu quả.',
  'faq.deposits.q2': 'Nạp tiền mất bao lâu để xử lý?',
  'faq.deposits.a2': 'Nạp bằng thẻ thường tức thì, trong khi chuyển khoản ngân hàng có thể mất 1–3 ngày làm việc. Thanh toán điện tử thường xử lý trong vài giờ.',
  'faq.deposits.q3': 'Có phí nạp tiền không?',
  'faq.deposits.a3': 'Chúng tôi không thu phí cho hầu hết phương thức nạp. Tuy nhiên, ngân hàng hoặc nhà cung cấp thanh toán của bạn có thể thu phí xử lý riêng, tùy từng đơn vị.',
  'faq.deposits.q4': 'Làm sao rút tiền?',
  'faq.deposits.a4': 'Bạn có thể yêu cầu rút tiền qua cổng khách hàng. Tiền thường được hoàn về cùng phương thức đã nạp; thời gian xử lý tùy theo phương thức thanh toán.',

  // Security
  'faq.security.q1': 'Bạn bảo vệ thông tin cá nhân của tôi như thế nào?',
  'faq.security.a1': 'Chúng tôi sử dụng mã hóa cấp ngân hàng (SSL 256-bit) để bảo vệ mọi truyền tải dữ liệu. Thông tin cá nhân của bạn được lưu trữ an toàn và không chia sẻ cho bên thứ ba nếu không có sự đồng ý.',
  'faq.security.q2': 'Có xác thực hai yếu tố không?',
  'faq.security.a2': 'Có, chúng tôi khuyến nghị bật xác thực hai yếu tố (2FA) cho tài khoản của bạn. Điều này thêm một lớp bảo mật để chống truy cập trái phép.',
  'faq.security.q3': 'Nếu tôi quên mật khẩu thì sao?',
  'faq.security.a3': 'Bạn có thể đặt lại mật khẩu bằng liên kết “Quên mật khẩu” trên trang đăng nhập. Bạn sẽ nhận được liên kết đặt lại an toàn qua email để tạo mật khẩu mới.',
  'faq.security.q4': 'Bạn đảm bảo điều kiện giao dịch công bằng như thế nào?',
  'faq.security.a4': 'Chúng tôi cung cấp báo giá minh bạch với nguồn dữ liệu thị trường thời gian thực, không can thiệp bàn giao dịch (no dealing desk) và tuân thủ pháp lý nghiêm ngặt để đảm bảo điều kiện giao dịch công bằng, đạo đức cho mọi khách hàng.',

  // Hero (FAQ CTA)
  'hero.browseFAQ': 'Duyệt mục Hỏi đáp',
  'hero.contactSupport': 'Liên hệ hỗ trợ',

  // Contact CTA
  'contactCTA.phoneTitle': 'Hỗ trợ qua điện thoại',
  'contactCTA.phoneDesc': 'Trò chuyện trực tiếp với chuyên gia của chúng tôi',
  'contactCTA.callNow': 'Gọi ngay',
  'contactCTA.emailTitle': 'Hỗ trợ qua email',
  'contactCTA.emailDesc': 'Nhận phản hồi chi tiết bằng văn bản',
  'contactCTA.sendMsg': 'Gửi tin nhắn',
  'contactCTA.chatTitle': 'Trò chuyện trực tuyến',
  'contactCTA.chatDesc': 'Hỗ trợ nhắn tin tức thời',
  'contactCTA.available': 'Hoạt động 24/7',
  'contactCTA.startChat': 'Bắt đầu chat',
  'contactCTA.title': 'Vẫn cần trợ giúp?',
  'contactCTA.subtitle': 'Đội ngũ hỗ trợ chuyên gia của chúng tôi sẵn sàng 24/7 để hỗ trợ mọi câu hỏi hoặc mối quan ngại của bạn.',

  "hero.cta.accountOpening": "Quy trình mở tài khoản",
  "hero.cta.depositWithdraw": "Quy trình nạp và rút tiền",
  "androidDownload.title": "Tải MetaTrader 5",
  "androidDownload.description": "Bạn sẽ được tự động chuyển đến Google Play. Nếu thiết bị của bạn không dùng được Google Play, bạn có thể tải APK trực tiếp.",
  "androidDownload.autoRedirect": "Chuyển đến Google Play sau {{seconds}} giây",
  "androidDownload.openGooglePlay": "Mở Google Play",
  "androidDownload.downloadApk": "Tải APK trực tiếp",
  "androidDownload.hint": "Nếu Google Play không mở, vui lòng nhấn “Tải APK trực tiếp”.",
  'windowsDownload.pageTitle': 'Tải Windows MT5',
  'windowsDownload.pageDesc': 'Vui lòng chọn phiên bản cài đặt phù hợp.',
  'windowsDownload.badge': 'Tải Windows MT5',
  'windowsDownload.title': 'Chọn gói cài đặt',
  'windowsDownload.description': 'Vui lòng chọn gói cài đặt Windows MT5. Gold Label Smooth Stable Version được khuyến nghị cho người dùng Trung Quốc đại lục và Hồng Kông. Bạn cũng có thể chọn bộ cài chính thức.',
  'windowsDownload.smoothTitle': '1. Gold Label Smooth Stable Version',
  'windowsDownload.smoothDesc': 'Khuyến nghị cho người dùng Windows tại Trung Quốc đại lục / Hồng Kông. Người dùng khu vực khác cũng có thể sử dụng nếu bộ cài chính thức không thuận tiện.',
  'windowsDownload.smoothButton': 'Tải Gold Label Smooth Stable Version',
  'windowsDownload.officialTitle': '2. Bộ cài chính thức MetaQuotes',
  'windowsDownload.officialDesc': 'Liên kết tải xuống gốc. Người dùng Windows tại Trung Quốc đại lục đôi khi có thể gặp vấn đề khi cài đặt; khách hàng ở khu vực khác không bị ảnh hưởng.',
  'windowsDownload.officialButton': 'Tải bộ cài chính thức',

  // Economic calendar explorer
  'calendar.hongKongTime': 'Giờ Hồng Kông (GMT+8)',
  'calendar.previousDays': '7 ngày trước',
  'calendar.nextDays': '7 ngày tiếp theo',
  'calendar.today': 'Hôm nay',
  'calendar.jumpToDate': 'Chuyển đến ngày',
  'calendar.completeView': 'Xem đầy đủ',
  'calendar.allDays': 'Toàn bộ 7 ngày',
  'calendar.events': 'sự kiện',
  'calendar.impactAll': 'Mọi mức tác động',
  'calendar.impactHigh': 'Cao',
  'calendar.impactMedium': 'Trung bình',
  'calendar.impactLow': 'Thấp',
  'calendar.searchPlaceholder': 'Tìm sự kiện, quốc gia hoặc tiền tệ',
  'calendar.eventsFound': 'sự kiện đang hiển thị',
  'calendar.lastUpdated': 'Cập nhật lần cuối',
  'calendar.loadError': 'Lịch kinh tế tạm thời không khả dụng.',
  'calendar.noEvents': 'Không có sự kiện kinh tế phù hợp với chế độ xem này.',
  'calendar.tryAnotherDate': 'Chọn ngày khác hoặc xóa bộ lọc.',
  'calendar.time': 'Thời gian',
  'calendar.impact': 'Tác động',
  'calendar.released': 'Đã công bố',
  'calendar.pending': 'Chờ công bố',
  'calendar.disclaimer': 'Thời gian theo giờ Hồng Kông. Số liệu có thể được điều chỉnh và chỉ mang tính tham khảo.',
  'news.tab.newsDesc': 'Tin thị trường mới nhất, phân tích vàng và nội dung giáo dục',
  'news.tab.calendarDesc': 'Xem các sự kiện kinh tế quan trọng và số liệu công bố quanh ngày đã chọn',
  'news.autoRefresh': 'Thông tin tin tức được tự động làm mới',

  'news.tabs.news': 'Tin tức',
  'news.tabs.calendar': 'Lịch kinh tế',

  // Complete the shared navigation, market specifications and licence page.
  'nav.license': 'Giấy phép',
  'nav.toggleMenu': 'Mở hoặc đóng menu',
  'markets.specsTitle': 'Quy tắc giao dịch',
  'markets.specsDisclaimer': '* Điều kiện giao dịch phụ thuộc vào cài đặt nền tảng và thanh khoản thị trường.',
  'markets.spreadTypeFloating': 'Chênh lệch giá thả nổi',
  'markets.points': 'điểm',
  'markets.variableByMarket': 'Thay đổi theo thị trường',
  'markets.table.symbol': 'Mã giao dịch',
  'markets.table.contractUnit': 'Đơn vị hợp đồng',
  'markets.table.minLot': 'Lot tối thiểu',
  'markets.table.maxLot': 'Lot tối đa',
  'markets.table.leverage': 'Đòn bẩy',
  'markets.table.spreadType': 'Loại chênh lệch giá',
  'markets.table.avgSpread': 'Chênh lệch giá trung bình',
  'markets.table.swapLong': 'Phí qua đêm vị thế mua',
  'markets.table.swapShort': 'Phí qua đêm vị thế bán',
  'markets.contractSections.contractSize.title': 'Quy mô hợp đồng',
  'markets.contractSections.contractSize.items.xauusd.label': 'Vàng (XAUUSD)',
  'markets.contractSections.contractSize.items.xauusd.desc': 'Quy mô hợp đồng tiêu chuẩn cho giao dịch vàng',
  'markets.contractSections.contractSize.items.xagusd.label': 'Bạc (XAGUSD)',
  'markets.contractSections.contractSize.items.xagusd.desc': 'Quy mô hợp đồng tiêu chuẩn cho giao dịch bạc',
  'markets.contractSections.contractSize.items.gaucnh.label': 'GAUCNH',
  'markets.contractSections.contractSize.items.gaucnh.desc': 'Quy mô hợp đồng tiêu chuẩn cho giao dịch liên quan đến Nhân dân tệ ở nước ngoài',
  'markets.contractSections.priceMove.title': 'Biến động giá tối thiểu',
  'markets.contractSections.priceMove.items.goldTick.label': 'Bước giá vàng',
  'markets.contractSections.priceMove.items.goldTick.desc': 'Mức thay đổi giá nhỏ nhất',
  'markets.contractSections.priceMove.items.silverTick.label': 'Bước giá bạc',
  'markets.contractSections.priceMove.items.silverTick.desc': 'Mức thay đổi giá nhỏ nhất',
  'markets.contractSections.priceMove.items.fxTick.label': 'Bước giá ngoại hối',
  'markets.contractSections.priceMove.items.fxTick.desc': 'Mức thay đổi nhỏ nhất trong báo giá cặp tiền tệ',
  'markets.contractSections.settlement.title': 'Phương thức thanh toán',
  'markets.contractSections.settlement.items.type.label': 'Loại thanh toán',
  'markets.contractSections.settlement.items.type.value': 'Thanh toán bằng tiền mặt',
  'markets.contractSections.settlement.items.type.desc': 'Không yêu cầu giao nhận vật chất',
  'markets.contractSections.settlement.items.currency.label': 'Đồng tiền thanh toán',
  'markets.contractSections.settlement.items.currency.desc': 'Các sản phẩm kim loại được thanh toán bằng Đô la Mỹ',
  'markets.contractSections.settlement.items.fxQuote.label': 'Đồng tiền định giá',
  'markets.contractSections.settlement.items.fxQuote.desc': 'GAUCNH được định giá theo CNH',
  'markets.contractSections.positionLimits.title': 'Giới hạn vị thế',
  'markets.contractSections.positionLimits.items.maxPosition.label': 'Vị thế tối đa',
  'markets.contractSections.positionLimits.items.maxPosition.desc': 'Cho mỗi sản phẩm trên mỗi tài khoản',
  'markets.contractSections.positionLimits.items.orderDistance.label': 'Khoảng cách đặt lệnh',
  'markets.contractSections.positionLimits.items.orderDistance.desc': 'Khoảng cách tối thiểu so với giá thị trường',
  'markets.contractSections.positionLimits.items.execution.label': 'Chế độ khớp lệnh',
  'markets.contractSections.positionLimits.items.execution.value': 'Khớp lệnh theo thị trường',
  'markets.contractSections.positionLimits.items.execution.desc': 'Lệnh được thực hiện dựa trên điều kiện thanh khoản thị trường',
  'markets.days.monday': 'Thứ Hai',
  'markets.days.tuesday': 'Thứ Ba',
  'markets.days.wednesday': 'Thứ Tư',
  'markets.days.thursday': 'Thứ Năm',
  'markets.days.friday': 'Thứ Sáu',
  'markets.days.saturday': 'Thứ Bảy',
  'markets.days.sunday': 'Chủ nhật',
  'markets.hours.monThu': '06:00 - 04:59',
  'markets.hours.friday': '06:00 - 04:57',
  'markets.hours.closed': 'Thị trường đóng cửa',
  'markets.holidays.newYear.date': 'Ngày 1 tháng 1',
  'markets.holidays.newYear.event': 'Tết Dương lịch',
  'markets.holidays.christmas.date': 'Ngày 25 tháng 12',
  'markets.holidays.christmas.event': 'Lễ Giáng sinh',
  'markets.holidays.independence.date': 'Ngày 4 tháng 7',
  'markets.holidays.independence.event': 'Ngày Quốc khánh Hoa Kỳ',
  'markets.holidays.thanksgiving.date': 'Ngày 24 tháng 11',
  'markets.holidays.thanksgiving.event': 'Lễ Tạ ơn (Hoa Kỳ)',
  'news.pageTitle': 'Tin tức tài chính',
  'news.pageDesc': 'Thông tin chọn lọc về vàng, thị trường, lãi suất và ngân hàng trung ương. Nội dung bài viết được cung cấp bằng tiếng Trung phồn thể, tiếng Trung giản thể và tiếng Anh.',
  'news.searchPlaceholder': 'Tìm tin tức',
  'news.empty': 'Không có tin tức phù hợp với bộ lọc',
  'news.filter.all': 'Tất cả',
  'news.filter.gold': 'Vàng',
  'news.filter.markets': 'Thị trường',
  'news.filter.rates': 'Lãi suất',
  'news.filter.centralBank': 'Ngân hàng trung ương',
  'news.filter.logistics': 'Vận chuyển',
  'license.hero.badge': 'Chứng nhận chính thức',
  'license.hero.title': 'Giấy phép thành viên Sở Giao dịch Vàng Hồng Kông',
  'license.hero.subtitle': 'GOLD LABEL GLOBAL LIMITED là thành viên số 10 của Sở Giao dịch Vàng Hồng Kông, được chính thức công nhận và giám sát, mang đến sự đảm bảo cao nhất cho hoạt động giao dịch kim loại quý của bạn.',
  'license.hero.badge1': 'Thành viên được cấp phép chính thức',
  'license.hero.badge2': 'Thành viên số 10',
  'license.hero.badge3': 'Được Chính quyền Hồng Kông công nhận',
  'license.details.badge': 'Chi tiết giấy phép',
  'license.details.title': 'Giấy phép chính thức của chúng tôi',
  'license.details.subtitle': 'Được Sở Giao dịch Vàng Hồng Kông cấp phép và giám sát đầy đủ, cung cấp dịch vụ giao dịch kim loại quý theo tiêu chuẩn cao nhất',
  'license.image.label': 'Tài liệu giấy phép chính thức',
  'license.image.placeholder': 'Giấy chứng nhận',
  'license.image.desc': 'Giấy phép thành viên chính thức của Sở Giao dịch Vàng Hồng Kông',
  'license.image.verified': 'Được Sở Giao dịch Vàng Hồng Kông xác minh',
  'license.member.label': 'Số thành viên',
  'license.member.title': 'Thành viên Sở Giao dịch Vàng Hồng Kông',
  'license.info.title': 'Về tư cách thành viên của chúng tôi',
  'license.info.desc1': 'GOLD LABEL GLOBAL LIMITED là thành viên chính thức của Chinese Gold & Silver Exchange Society (Sở Giao dịch Vàng Hồng Kông), mang số thành viên 10. Đây là tổ chức giao dịch kim loại quý lâu đời và lớn nhất Hồng Kông, được thành lập hơn 100 năm trước và là một trong những trung tâm giao dịch vàng quan trọng nhất thế giới.',
  'license.info.desc2': 'Là thành viên chính thức, chúng tôi tuân thủ nghiêm ngặt mọi quy tắc và yêu cầu giám sát của Sở, đảm bảo mỗi giao dịch diễn ra trong môi trường minh bạch, công bằng và an toàn, bảo vệ đầy đủ lợi ích của từng khách hàng.',
  'license.info.org.label': 'Cơ quan giám sát',
  'license.info.org.value': 'Chinese Gold & Silver Exchange Society (Sở Giao dịch Vàng Hồng Kông)',
  'license.info.member.label': 'Số thành viên',
  'license.info.member.value': 'Thành viên số 10',
  'license.info.jurisdiction.label': 'Khu vực tài phán',
  'license.info.jurisdiction.value': 'Đặc khu Hành chính Hồng Kông',
  'license.info.status.label': 'Trạng thái giấy phép',
  'license.info.status.value': 'Đang hoạt động và tuân thủ',
  'license.features.title': 'Ý nghĩa của tư cách thành viên',
  'license.features.official.title': 'Được công nhận chính thức',
  'license.features.official.desc': 'Được Sở Giao dịch Vàng Hồng Kông chính thức công nhận, đáp ứng mọi yêu cầu giám sát và tiêu chuẩn ngành',
  'license.features.trading.title': 'Được phép giao dịch',
  'license.features.trading.desc': 'Đủ tư cách pháp lý để kinh doanh giao dịch kim loại quý và tuân thủ đầy đủ các quy định',
  'license.features.regulated.title': 'Giám sát nghiêm ngặt',
  'license.features.regulated.desc': 'Chịu sự giám sát chặt chẽ của Sở, cùng các đợt rà soát tuân thủ và kiểm toán định kỳ',
  'license.features.international.title': 'Uy tín quốc tế',
  'license.features.international.desc': 'Tư cách thành viên được công nhận rộng rãi trên toàn cầu, tạo dựng uy tín quốc tế',
  'license.features.market.title': 'Tiếp cận thị trường',
  'license.features.market.desc': 'Tham gia trực tiếp thị trường của Sở và tiếp cận nguồn thanh khoản chất lượng cao',
  'license.features.network.title': 'Mạng lưới trong ngành',
  'license.features.network.desc': 'Tham gia mạng lưới rộng lớn trong ngành, xây dựng quan hệ đối tác đáng tin cậy với các tổ chức tài chính được quản lý khác',
  'license.exchange.badge': 'Về Sở Giao dịch',
  'license.exchange.title': 'Chinese Gold & Silver Exchange Society — Hơn một thế kỷ lịch sử',
  'license.exchange.desc1': 'Chinese Gold & Silver Exchange Society (Sở Giao dịch Vàng Hồng Kông) được thành lập năm 1910 và là tổ chức giao dịch kim loại quý lâu đời nhất Hồng Kông. Trong hơn một thế kỷ, Sở giữ vai trò trung tâm của thị trường kim loại quý tại Hồng Kông và châu Á.',
  'license.exchange.desc2': 'Sở duy trì hệ thống thành viên nghiêm ngặt: chỉ những doanh nghiệp đáp ứng điều kiện và vượt qua quá trình thẩm định toàn diện mới được trở thành thành viên chính thức. Việc công ty đạt tư cách thành viên số 10 thể hiện năng lực chuyên môn và uy tín của chúng tôi.',
  'license.exchange.stat1.value': '1910',
  'license.exchange.stat1.label': 'Năm thành lập Sở',
  'license.exchange.stat2.value': '100+',
  'license.exchange.stat2.label': 'Năm lịch sử',
  'license.exchange.stat3.value': '80 tỷ HK$',
  'license.exchange.stat3.label': 'Khối lượng giao dịch hằng ngày',
  'license.exchange.stat4.value': 'Toàn cầu',
  'license.exchange.stat4.label': 'Uy tín quốc tế',
  'license.exchange.img.caption': 'Chinese Gold & Silver Exchange Society',
  'license.exchange.img.sub': 'Sở giao dịch kim loại quý hàng đầu Hồng Kông',
  'license.exchange.badge.number': 'Thành viên số 10',

  // Previously hard-coded UI strings on the home, platform and news pages.
  'download.checkingRegion': 'Đang xác định khu vực…',
  'download.scanWindows': 'Quét mã hoặc nhấn để tải cho Windows',
  'download.scanIos': 'Quét mã hoặc nhấn để tải cho iOS',
  'download.scanAndroid': 'Quét mã hoặc nhấn để tải cho Android',
  'download.appStorePrompt': 'Tải trên',
  'download.googlePlayPrompt': 'Tải trên',
  'download.version': 'Phiên bản {{version}}',
  'download.size': 'Dung lượng: {{size}}',
  'download.windowsRequirements': 'Windows 10/11, RAM 2 GB, dung lượng lưu trữ 1 GB',
  'download.macRequirements': 'macOS 10.15+, RAM 4 GB, dung lượng lưu trữ 1 GB',
  'download.mobile': 'Thiết bị di động',
  'download.internet': 'Kết nối Internet',
  'home.mt5Platform': 'nền tảng MT5',
  'markets.status.live': 'Trực tiếp',
  'markets.status.delayed': 'Có độ trễ',
  'markets.livePrice': 'Giá trực tiếp',
  'markets.sell': 'Bán',
  'markets.buy': 'Mua',
  'markets.dayHigh': 'Cao nhất trong ngày',
  'markets.dayLow': 'Thấp nhất trong ngày',
  'markets.lastUpdate': 'Cập nhật lần cuối',
  'markets.hongKongTime': 'Giờ Hồng Kông',
  'markets.preciousMetals': 'Kim loại quý',
  'markets.liveSubtitle': 'Theo dõi giá vàng và bạc tham khảo mới nhất trong cùng một màn hình.',
  'markets.indicativeDisclaimer': 'Giá chỉ mang tính tham khảo, có thể có độ trễ và không phải là giá có thể thực hiện giao dịch.',
  'markets.quotesUnavailable': 'Dữ liệu giá thị trường tạm thời không khả dụng.',
  'markets.informationDisclaimer': 'Giá và thông tin thị trường chỉ mang tính tham khảo và có thể có độ trễ. Nội dung chỉ nhằm cung cấp thông tin, không phải là tư vấn đầu tư.',
  'markets.heroMetals': 'Vàng và bạc',
  'markets.heroTradingMarket': 'Thị trường giao dịch',
  'calendar.to': 'đến',
  'calendar.noEventsForPeriod': 'Không có sự kiện kinh tế trong giai đoạn này.',
  'news.noCurrentNews': 'Hiện chưa có tin thị trường.',
  'news.updatedHourly': 'Cập nhật hằng giờ',
  'news.viewAll': 'Xem tất cả tin tức',
  'news.live.all': 'Tất cả tin tức',
  'news.live.general': 'Tổng hợp',
  'news.live.forex': 'Ngoại hối',
  'news.live.stock': 'Cổ phiếu',
  'news.live.crypto': 'Tiền mã hóa',
  'news.live.search': 'Tìm tin thị trường mới nhất',
  'news.live.empty': 'Không tìm thấy tin thị trường phù hợp.',
  'news.live.unavailable': 'Tin thị trường mới nhất tạm thời không khả dụng.',
  'news.archive.title': 'Góc nhìn thị trường vàng',
  'news.archive.description': 'Các bài nghiên cứu và bình luận thị trường mang tính giáo dục.',
  'news.language.traditional': 'Tiếng Trung phồn thể',
  'news.language.simplified': 'Tiếng Trung giản thể',
  'news.language.english': 'Tiếng Anh',
  'news.readFullArticle': 'Đọc toàn bộ bài viết',
  'news.backToMarket': 'Quay lại tin thị trường',
  'news.notFoundTitle': 'Không tìm thấy bài viết',
  'news.notFoundText': 'Bài viết có thể đã bị xóa hoặc đường dẫn không chính xác.',
  'news.contentLanguage': 'Ngôn ngữ bài viết',
  'news.articleBody': 'Nội dung bài viết',
  'news.marketIntelligence': 'Nội dung thông tin thị trường',
  'news.dateLocale': 'vi-VN',
  'legal.eyebrow': 'Tài liệu pháp lý',
  'legal.heading': 'Tài liệu pháp lý của Gold Label Global',
  'legal.subtitle': 'Vui lòng đọc kỹ các tài liệu pháp lý áp dụng cho trang web, việc mở tài khoản và các dịch vụ liên quan.',
  'legal.terms': 'Thỏa thuận người dùng',
  'legal.privacy': 'Chính sách quyền riêng tư',
  'legal.risk': 'Công bố rủi ro kim loại quý',
  'legal.loading': 'Đang tải tài liệu…',
  'legal.error': 'Tài liệu tạm thời không khả dụng. Vui lòng thử lại sau.',
  'legal.originalLanguage': 'Tài liệu bên dưới được cung cấp bằng tiếng Anh.',
  'notFound.title': 'Không tìm thấy trang',
  'notFound.description': 'Trang bạn yêu cầu không tồn tại hoặc đã được chuyển sang địa chỉ khác.',
  'home.partners.network': 'Mạng lưới toàn cầu JLB',
  'contact.addressFloor': 'Phòng 3404–3406, tầng 34',
  'contact.hongKong': 'Hồng Kông',
  'contact.visitOffice': 'Ghé thăm văn phòng của chúng tôi',
  'contact.officeLocation': 'Nằm tại trung tâm khu tài chính Hồng Kông.',
  'contact.openMaps': 'Mở trong Google Maps',
  'contact.mapTitle': 'Vị trí văn phòng GOLD LABEL GLOBAL LIMITED',
  'contact.placeholder.name': 'Nhập họ và tên của bạn',
  'contact.placeholder.email': 'Nhập địa chỉ email của bạn',
  'contact.placeholder.phone': 'Nhập số điện thoại của bạn',
  'contact.placeholder.subject': 'Nhập chủ đề yêu cầu',
  'contact.placeholder.message': 'Vui lòng mô tả chi tiết yêu cầu của bạn…',
  'contact.characters': 'ký tự',
  'contact.sending': 'Đang gửi tin nhắn…',
  'contact.sent': 'Cảm ơn bạn! Tin nhắn đã được gửi thành công. Chúng tôi sẽ phản hồi trong vòng 24 giờ.',
  'contact.sendError': 'Đã xảy ra lỗi khi gửi tin nhắn. Vui lòng thử lại hoặc liên hệ trực tiếp với chúng tôi.',
  'androidDownload.checking': 'Đang xác định khu vực của bạn. Vui lòng chờ.',
  'androidDownload.choiceTitle': 'Tải và cài đặt MT5 cho Android',
  'androidDownload.choiceDescription': 'Hệ thống xác định bạn đang ở Trung Quốc đại lục hoặc Hồng Kông. Bạn nên sử dụng bộ cài APK của Gold Label. Nếu thiết bị có thể sử dụng Google Play bình thường, bạn cũng có thể chọn liên kết tải chính thức.',
  'androidDownload.choiceHint': 'Nếu không thể sử dụng Google Play tại Trung Quốc đại lục hoặc Hồng Kông, hãy chọn bộ cài APK của Gold Label.',
  'androidDownload.apkOption': '1. Bộ cài APK của Gold Label',
  'androidDownload.officialOption': '2. Google Play / Tải chính thức',
  'androidDownload.otherRegions': 'Khách hàng tại các khu vực khác sẽ tự động được chuyển đến liên kết tải Google Play / MetaQuotes chính thức và không thấy trang lựa chọn này.',

  // Market risk tools and account labels.
  "markets.risk.stop.title": "Lệnh cắt lỗ",
  "markets.risk.stop.description": "Tự động đóng vị thế khi mức lỗ chạm ngưỡng đã đặt",
  "markets.risk.stop.execution": "Đảm bảo khớp lệnh tại mức giá chỉ định",
  "markets.risk.stop.protection": "Bảo vệ trước biến động thị trường bất lợi",
  "markets.risk.stop.availability": "Sẵn có trong suốt giờ giao dịch",
  "markets.risk.stop.fees": "Không có phí hoặc khoản thu bổ sung",
  "markets.risk.profit.title": "Lệnh chốt lời",
  "markets.risk.profit.description": "Chốt lợi nhuận khi giá đạt mục tiêu",
  "markets.risk.profit.automatic": "Tự động bảo toàn lợi nhuận",
  "markets.risk.profit.emotions": "Loại bỏ quyết định giao dịch theo cảm xúc",
  "markets.risk.profit.targets": "Đặt nhiều mục tiêu lợi nhuận",
  "markets.risk.profit.partial": "Hỗ trợ đóng một phần vị thế",
  "markets.risk.margin.title": "Bảo vệ bằng cảnh báo ký quỹ",
  "markets.risk.margin.description": "Hệ thống cảnh báo nâng cao giúp bảo vệ tài khoản",
  "markets.risk.margin.monitoring": "Theo dõi mức ký quỹ theo thời gian thực",
  "markets.risk.margin.notifications": "Thông báo qua email và SMS",
  "markets.risk.margin.closure": "Tự động đóng vị thế khi mức ký quỹ còn 20%",
  "markets.risk.margin.negative": "Bảo vệ số dư âm",
  "markets.risk.sizing.title": "Xác định quy mô vị thế",
  "markets.risk.sizing.description": "Tính quy mô vị thế tối ưu dựa trên khả năng chấp nhận rủi ro",
  "markets.risk.sizing.calculator": "Công cụ tính tỷ lệ rủi ro",
  "markets.risk.sizing.lots": "Đề xuất số lot tối đa",
  "markets.risk.sizing.diversification": "Công cụ đa dạng hóa danh mục",
  "markets.risk.sizing.ratio": "Phân tích tỷ lệ rủi ro và lợi nhuận",
  "markets.risk.levels.conservative": "Thận trọng",
  "markets.risk.levels.conservativeDescription": "Rủi ro thấp, hướng đến tăng trưởng ổn định",
  "markets.risk.levels.moderate": "Cân bằng",
  "markets.risk.levels.moderateDescription": "Chiến lược cân bằng giữa rủi ro và lợi nhuận",
  "markets.risk.levels.aggressive": "Mạo hiểm",
  "markets.risk.levels.aggressiveDescription": "Chấp nhận rủi ro cao hơn để tìm kiếm lợi nhuận tiềm năng cao hơn",
  "markets.account.standard": "Tài khoản tiêu chuẩn",
  "markets.account.premium": "Tài khoản cao cấp",
  "markets.account.vip": "Tài khoản VIP",
  "markets.contract.value.goldSize": "100 ounce",
  "markets.contract.value.silverSize": "5.000 ounce",
  "markets.contract.value.maxPosition": "1.000 lot",
  "markets.contract.value.orderDistance": "50 điểm",
  "platform.executionSpeedStat": "Tốc độ 0,01 giây",

};
export default common;
